{
  "name": "@smart-office-repo/source",
  "version": "1.5.6",
  "license": "MIT",
  "scripts": {
    "start": "nx serve smart-office-app --open"
  },
  "private": true,
  "devDependencies": {
    "@angular-devkit/core": "^21.1.0",
    "@angular-devkit/schematics": "^21.1.0",
    "@angular/build": "^21.1.0",
    "@angular/cli": "^21.1.0",
    "@angular/compiler-cli": "^21.1.0",
    "@angular/language-service": "^21.1.0",
    "@eslint/js": "^9.8.0",
    "@nx/angular": "^22.3.3",
    "@nx/eslint": "22.3.3",
    "@nx/eslint-plugin": "22.3.3",
    "@nx/jest": "22.3.3",
    "@nx/js": "22.3.3",
    "@nx/playwright": "22.3.3",
    "@nx/web": "22.3.3",
    "@nx/workspace": "22.3.3",
    "@schematics/angular": "^21.1.0",
    "@swc-node/register": "~1.9.1",
    "@swc/core": "^1.15.0",
    "@swc/helpers": "~0.5.11",
    "@tailwindcss/postcss": "^4.1.10",
    "@types/jest": "^30.0.0",
    "@types/leaflet": "^1.9.12",
    "@types/leaflet.fullscreen": "^5.2.0",
    "@types/luxon": "^3.7.1",
    "@types/node": "20.19.9",
    "@typescript-eslint/utils": "^8.40.0",
    "angular-eslint": "^21.0.1",
    "autoprefixer": "^10.4.0",
    "eslint": "^9.29.0",
    "jest": "^30.0.2",
    "jest-environment-jsdom": "^30.0.2",
    "jest-preset-angular": "~16.0.0",
    "jest-util": "^30.0.2",
    "nx": "22.3.3",
    "playwright": "1.53.1",
    "postcss": "^8.5.6",
    "sass": "^1.97.3",
    "stylelint": "16.21.0",
    "tailwindcss": "^4.1.10",
    "tailwindcss-primeui": "^0.6.1",
    "ts-jest": "^29.4.0",
    "ts-node": "10.9.1",
    "tslib": "^2.3.0",
    "typescript": "~5.9.2",
    "typescript-eslint": "^8.40.0"
  },
  "dependencies": {
    "@angular/animations": "^21.1.0",
    "@angular/common": "^21.1.0",
    "@angular/compiler": "^21.1.0",
    "@angular/core": "^21.1.0",
    "@angular/forms": "^21.1.0",
    "@angular/platform-browser": "^21.1.0",
    "@angular/platform-browser-dynamic": "^21.1.0",
    "@angular/router": "^21.1.0",
    "@primeng/themes": "^21.0.3",
    "axios": "1.10.0",
    "buffer": "^6.0.3",
    "chart.js": "4.5.0",
    "chartjs-plugin-zoom": "^2.2.0",
    "date-fns": "^4.1.0",
    "leaflet": "^1.9.4",
    "leaflet-easybutton": "^2.4.0",
    "leaflet.fullscreen": "^5.3.0",
    "luxon": "3.5.0",
    "mqtt": "^5.14.1",
    "primeicons": "^7.0.0",
    "primeng": "^21.0.3",
    "process": "^0.11.10",
    "rxjs": "~7.8.0"
  }
}
